export { default } from './BookmarkIcon';
